import * as React from "react";
import config from "../../config/config";
import Overview from "../../components/OverviewTable/Overview";
import t from "../../hooks/useTranslation";
import useDetailData from "../../hooks/useDetailData";
import ProductForm from "./ProductForm";

import './ProductDetail.css';

function ProductDetail(props) {
    const {isLoading, error, response} = useDetailData(config.apiRouteMap.getProduct);

    return (
        <div className="ProductDetail app__main">
            <Overview
                isLoading={isLoading}
                title={t('productDetail')}
                error={error}
            >
                <ProductForm
                    history={props.history}
                    data={response}
                    isLoading={isLoading}
                    error={error}
                />
            </Overview>
        </div>
    );
}

export default ProductDetail;
